import { render, staticRenderFns } from "./distribution-panel-form.component.vue?vue&type=template&id=b7dc402a"
import script from "./distribution-panel-form.component.ts?vue&type=script&lang=ts&external"
export * from "./distribution-panel-form.component.ts?vue&type=script&lang=ts&external"
import style0 from "./distribution-panel-form.component.vue?vue&type=style&index=0&id=b7dc402a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports